import { useFormik } from 'formik';
import { useEffect } from 'react';
import { Param } from '../../../../../../shared/types/param';

export const useSubtypeDPRegisterHistory = (subtypeDP?: Param) => {
    const formik = useFormik({
        initialValues: {
            createdBy: '',
            updatedBy: '',
        },
        onSubmit: console.log,
    });

    useEffect(() => {
        const { createdBy, updatedBy } = subtypeDP || {};
        formik.setValues({
            createdBy: createdBy
                ? `(${createdBy.username}) ${createdBy.name} ${createdBy.surname}`
                : '',
            updatedBy: updatedBy
                ? `(${updatedBy.username}) ${updatedBy.name} ${updatedBy.surname}`
                : '',
        });
    }, [subtypeDP]);

    return {
        formik,
    };
};
